/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchClassifyResponseClassifiersItem2 = typeof SearchClassifyResponseClassifiersItem2[keyof typeof SearchClassifyResponseClassifiersItem2];


export const SearchClassifyResponseClassifiersItem2 = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
